import React from "react";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton.jsx";
import { renderField, renderTimePicker } from "./_fieldRenderer";
import "./forms.css";

class ShiftForm extends React.Component {
  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="name"
                type="text"
                component={renderField}
                label="Nome"
                placeholder="Nome"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <FormGroup>
              <Field
                name="startAt"
                component={renderTimePicker}
                label="Início"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Field
                name="endAt"
                component={renderTimePicker}
                label="Conclusão"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Salvar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };
}

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Obrigatório";
  }
  if (!values.startAt) {
    errors.startAt = "Obrigatório";
  }
  if (!values.endAt) {
    errors.endAt = "Obrigatório";
  }
  return errors;
};

ShiftForm = reduxForm({ form: "ShiftForm", validate })(ShiftForm);
export default ShiftForm;



// WEBPACK FOOTER //
// ./src/forms/ShiftForm.jsx